/**
 * Добавление классов к элементу
 * @param className в одной строке можно передать несколько классов через пробел
 * Функция работает с элементом или с массивом элементов
 */
HTMLElement.prototype.addClass = function (className) {
	let el = this;

	if (className) {
		if (typeof className === 'string') {
			className = className.split(' ');
		}

		el.classList.add(...className);
	}
}

Array.prototype.addClass = function (className) {
	let arr = this;

	if (arr.length) {
		arr.forEach(function (el) {
			el.addClass(className)
		})
	}
}

/**
 * Удаление классов у элемента
 * @param className в одной строке можно передать несколько классов через пробел
 * Функция работает с элементом или с массивом элементов
 */
HTMLElement.prototype.removeClass = function (className) {
	let el = this;

	if (className) {
		if (typeof className === 'string') {
			className = className.split(' ');
		}

		el.classList.remove(...className);
	}
}

Array.prototype.removeClass = function (className) {
	let arr = this;

	if (arr.length) {
		arr.forEach(function (el) {
			if (className) {
				if (typeof className === 'string') {
					className = className.split(' ');
				}

				el.classList.remove(...className);
			}
		})
	}
}

/**
 * Есть ли класс у элемента
 * @param className
 */
HTMLElement.prototype.hasClass = function (className) {
	return this.classList.contains(className);
}


/**
 * Показать элемент, в качестве сss значения можно передать flex, inline-flex и т.п.
 * Работает с массивами
 * @param state
 */
HTMLElement.prototype.show = function (state = 'block') {
	this.style.display = state;
}

Array.prototype.show = function (state = 'block') {
	let arr = this;

	if (arr.length) {
		arr.forEach(function (el) {
			el.show(state);
		})
	}
}

/**
 * Скрыть элемент.
 * Работает с массивами
 */
HTMLElement.prototype.hide = function () {
	this.style.display = 'none';
}

Array.prototype.hide = function () {
	let arr = this;

	if (arr.length) {
		arr.forEach(function (el) {
			el.hide();
		})
	}
}
